import { axiosInstance } from './apiCommon';

export interface FeatureFlagAdminModel {
  key: string;
  isEnabled: boolean;
  createdBy: string;
  createdAt: string;
  modifiedBy: string;
  modifiedAt: string;
}

export const getAdminFeatureFlags = async (): Promise<FeatureFlagAdminModel[]> => {
  return (await axiosInstance.get<FeatureFlagAdminModel[]>('/api/admin/v1/AdminFeatureFlags')).data;
};

export const createAdminFeatureFlag = async (key: string, isEnabled: boolean): Promise<void> => {
  await axiosInstance.post('/api/admin/v1/AdminFeatureFlags', { key, isEnabled });
};

export const updateAdminFeatureFlag = async (key: string, isEnabled: boolean): Promise<void> => {
  await axiosInstance.put(`/api/admin/v1/AdminFeatureFlags/${encodeURIComponent(key)}`, { isEnabled });
};

export const deleteAdminFeatureFlag = async (key: string): Promise<void> => {
  await axiosInstance.delete(`/api/admin/v1/AdminFeatureFlags/${encodeURIComponent(key)}`);
};
